import { FC } from 'react';
import { theme } from '../constants';

type Props = {
  type?: 'text' | 'password' | 'tel';
  clickable?: boolean;
  containerStyle?: object;
  label?: string;
  autoCapitalize?: 'none' | 'sentences' | 'words' | 'characters';
  placeholder?: string;
  icon?: JSX.Element;
  value?: string;
  maxLength?: number;
  error?: string;
  onChange?: (value: string) => void;
};

export const InputField: FC<Props> = ({
  placeholder,
  containerStyle,
  autoCapitalize = 'none',
  label,
  icon,
  clickable,
  type = 'text',
  value,
  maxLength = 50,
   error,
  onChange,
}) => {
  return (
    <div
      style={{
        height: 50,
        paddingRight: 30,
        paddingLeft: 20,
        borderRadius: 12,
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#e8eff4',
        display: 'flex',
        ...containerStyle,
      }}
    >
      {label && (
        <div
          style={{
            position: 'absolute',
            top: -8,
            right: 20,
            paddingLeft: 10,
            paddingRight: 10,
            borderRadius: 12,
            backgroundColor: '#fff',
            fontSize: 12,
            color: theme.colors.textColor,
            textTransform: 'uppercase',
            fontFamily: 'Mulish-SemiBold',
          }}
        >
          {label}
        </div>
      )}
      <input
        className="input-field"
        autoCapitalize={autoCapitalize}
        placeholder={placeholder}
        maxLength={maxLength}
        type={type}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        style={{
          width: '100%',
          height: '100%',
          padding: 0,
          margin: 0,
          border: 'none',
          outline: 'none',
          backgroundColor: 'transparent',
          fontSize: 16,
          color: theme.colors.mainColor,
        }}
      />
      {icon && !clickable && <div>{icon}</div>}
      {icon && clickable && <button>{icon}</button>}
      {error && (
        <div style={{ marginTop: 6, color: 'red', fontSize: 13 }}>
          {error}
        </div>
      )}
    </div>
  );
};
